document.addEventListener('DOMContentLoaded', function() {
    const filterForm = document.getElementById('CollectionFiltersForm');
    const productGrid = document.querySelector('.product-grid');
    const DEFAULT_MIN_PRICE = 0;

    // Product cards navigation (ignore clicks on any input)
    document.querySelectorAll('.product-card').forEach(function(card) {
        card.addEventListener('click', function(e) {
            if (e.target.closest('input, label, .filter-content')) return;
            const url = card.getAttribute('data-url');
            if (url) window.location.href = url;
        });
    });

    // View switcher
    document.querySelectorAll('.view-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
            document.querySelectorAll('.view-btn').forEach(b => b.classList.remove('active'));
            this.classList.add('active');
            const grid = document.querySelector('.product-grid');
            grid.classList.remove('grid-3', 'grid-4', 'grid-list');
            grid.classList.add('grid-' + this.getAttribute('data-columns'));
        });
    });

    // Collapse/expand each filter
    document.querySelectorAll('.filter-header').forEach(function(header) {
        header.addEventListener('click', function(e) {
            if (e.target.closest('.reset-link')) return;
            header.classList.toggle('active');
            const content = header.nextElementSibling;
            content.style.display = (content.style.display === 'block') ? 'none' : 'block';
        });
    });

    // Clear All button - without reload
    const clearAllBtn = document.querySelector('.clear-all');
    if (clearAllBtn) {
        clearAllBtn.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Uncheck all checkboxes
            filterForm.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
            
            // Reset price inputs
            const minInput = document.getElementById('min-price-input');
            const maxInput = document.getElementById('max-price-input');
            if (minInput) minInput.value = DEFAULT_MIN_PRICE;
            if (maxInput) maxInput.value = '';
            
            // Reset any select dropdowns
            filterForm.querySelectorAll('select').forEach(sel => sel.selectedIndex = 0);
            
            // Hide all reset links
            document.querySelectorAll('.reset-link').forEach(link => {
                link.style.display = 'none';
            });
            
            // Hide all active counts
            document.querySelectorAll('.active-count').forEach(count => {
                count.style.display = 'none';
            });
            
            // Apply filters (will load unfiltered products)
            applyFilters();
        });
    }

    // Individual Reset links - without reload
    document.querySelectorAll('.reset-link').forEach(function(resetLink) {
        resetLink.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Get the filter parameter name
            const filterParam = this.getAttribute('data-filter-param');
            
            // Find the filter block
            const filterBlock = this.closest('.filter-block');
            
            // Reset based on filter type
            if (filterParam) {
                // Uncheck all checkboxes with this parameter name
                filterBlock.querySelectorAll(`input[type="checkbox"][name="${filterParam}"]`).forEach(cb => {
                    cb.checked = false;
                });
                
                // Reset price inputs if this is a price filter
                const minInput = filterBlock.querySelector('input[data-type="min"]');
                const maxInput = filterBlock.querySelector('input[data-type="max"]');
                
                if (minInput) {
                    minInput.value = DEFAULT_MIN_PRICE;
                }
                if (maxInput) {
                    maxInput.value = '';
                }
                
                // Reset any color swatches
                filterBlock.querySelectorAll('.color-swatch input[type="checkbox"]').forEach(cb => {
                    cb.checked = false;
                });
            } else {
                // Fallback: uncheck all in this block
                filterBlock.querySelectorAll('input[type="checkbox"]').forEach(cb => {
                    cb.checked = false;
                });
            }
            
            // Hide this reset link immediately
            this.style.display = 'none';
            
            // Hide active count for this filter
            const activeCount = filterBlock.querySelector('.active-count');
            if (activeCount) {
                activeCount.style.display = 'none';
            }
            
            // Apply filters to refresh products
            applyFilters();
        });
    });

    // Prevent clicks inside filter content from bubbling to header
    document.querySelectorAll('.filter-content').forEach(function(content) {
        content.addEventListener('click', function(e) { e.stopPropagation(); });
    });

    // =================== LIVE FILTERING WITHOUT RELOAD ===================
    
    function applyFilters() {
        // Show loading indicator
        if (productGrid) {
            productGrid.style.opacity = '0.5';
            productGrid.style.pointerEvents = 'none';
        }

        // Get form data
        const formData = new FormData(filterForm);
        const queryString = new URLSearchParams(formData).toString();
        
        // Update URL without reload
        const newUrl = window.location.pathname + (queryString ? '?' + queryString : '');
        window.history.pushState({}, '', newUrl);

        // Fetch filtered products
        fetch(newUrl, {
            headers: {
                'X-Requested-With': 'XMLHttpRequest' // Indicate AJAX request
            }
        })
        .then(response => response.text())
        .then(html => {
            // Create temporary element to parse response
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');


            // Get new product grid
            const newGrid = doc.querySelector('.product-grid');
            
            // 🔥 UPDATE PAGINATION
            const newPagination = doc.querySelector('.pagination-wrapper');
            const currentPagination = document.querySelector('.pagination-wrapper');

            if (currentPagination) {
                if (newPagination && newPagination.innerHTML.trim() !== "") {
                    currentPagination.innerHTML = newPagination.innerHTML;
                    currentPagination.style.display = "flex";
                } else {
                    currentPagination.innerHTML = "";
                    currentPagination.style.display = "none";
                }
            }
            
            if (newGrid && productGrid) {
                // Replace products
                productGrid.innerHTML = newGrid.innerHTML;
                
                // Reattach click handlers to new product cards
                productGrid.querySelectorAll('.product-card').forEach(function(card) {
                    card.addEventListener('click', function(e) {
                        if (e.target.closest('input, label, .filter-content')) return;
                        const url = card.getAttribute('data-url');
                        if (url) window.location.href = url;
                    });
                });

                // 🔥 RE-INIT QUICK VIEW FOR NEW CARDS
                initQuickViewScripts(productGrid);
            }
                       
            // Update product count if exists
            const newCount = doc.querySelector('.product-count');
            const currentCount = document.querySelector('.product-count');
            if (newCount && currentCount) {
                currentCount.textContent = newCount.textContent;
            }
            
            // Update filter UI
            updateFilterUI();
            
            // Restore grid appearance
            if (productGrid) {
                productGrid.style.opacity = '1';
                productGrid.style.pointerEvents = 'auto';
            }
            // 🔥 UPDATE ONLY FILTER COUNTS (SAFE)
            const newCounts = doc.querySelectorAll('#CollectionFiltersForm .filter-count');
            const currentCounts = document.querySelectorAll('#CollectionFiltersForm .filter-count');

            newCounts.forEach((newEl, index) => {
                if (currentCounts[index]) {
                    currentCounts[index].textContent = newEl.textContent;
                }
            });

            disableZeroCountFilters()
        })
        .catch(error => {
            console.error('Filter error:', error);
            // Restore on error
            if (productGrid) {
                productGrid.style.opacity = '1';
                productGrid.style.pointerEvents = 'auto';
            }
        });
    }
    
    function disableZeroCountFilters() {
        document.querySelectorAll('.filter-block').forEach(function(block) {
            const options = block.querySelectorAll('label');

            options.forEach(function(label) {
                const countEl = label.querySelector('.filter-count');
                const checkbox = label.querySelector('input[type="checkbox"]');

                if (!countEl || !checkbox) return;

                const countText = countEl.textContent.replace(/[()]/g, '');
                const count = parseInt(countText, 10);

                if (count === 0) {
                    checkbox.disabled = true;
                    label.classList.add('disabled-option');
                } else {
                    checkbox.disabled = false;
                    label.classList.remove('disabled-option');
                }
            });
        });
    }

    // Helper function to update filter UI after applying filters
    function updateFilterUI() {
        // Update active counts and reset links visibility for each filter
        document.querySelectorAll('.filter-block').forEach(function(filterBlock) {
            const filterHeader = filterBlock.querySelector('.filter-header');
            const resetLink = filterHeader.querySelector('.reset-link');
            const activeCount = filterHeader.querySelector('.active-count');
            
            // Count checked checkboxes in this filter
            const checkedCount = filterBlock.querySelectorAll('input[type="checkbox"]:checked').length;
            
            // Check if price inputs have values
            const minInput = filterBlock.querySelector('input[data-type="min"]');
            const maxInput = filterBlock.querySelector('input[data-type="max"]');
            const hasPriceFilter = (minInput && minInput.value && minInput.value != DEFAULT_MIN_PRICE && minInput.value != '0') || 
                                   (maxInput && maxInput.value && maxInput.value != '');
            
            const hasActiveFilters = checkedCount > 0 || hasPriceFilter;
            
            // Show/hide reset link based on active filters
            if (resetLink) {
                resetLink.style.display = hasActiveFilters ? 'inline-block' : 'none';
            }
            
            // Update active count
            if (activeCount) {
                if (hasActiveFilters) {
                    const displayCount = checkedCount > 0 ? checkedCount : 1;
                    activeCount.textContent = `(${displayCount})`;
                    activeCount.style.display = 'inline';
                } else {
                    activeCount.style.display = 'none';
                }
            }
        });
    }

    if (filterForm) {
        // Prevent default form submission
        filterForm.addEventListener('submit', function(e) {
            e.preventDefault();
            applyFilters();
        });

        // Auto-apply on checkbox & select change
        filterForm.addEventListener('change', function(e) {
            const t = e.target;
            if (t.matches('input[type="checkbox"], select')) {
                applyFilters();
            }
        });

        // Price inputs → apply only on blur or Enter
        const priceInputs = filterForm.querySelectorAll('input[type="number"]');
        priceInputs.forEach(inp => {
            inp.addEventListener('blur', () => {
                applyFilters();
            });
            inp.addEventListener('keypress', (e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    applyFilters();
                }
            });
        });
    }

    // Preserve min/max price values from URL OR set default
    const urlParams = new URLSearchParams(window.location.search);
    const minInput = document.getElementById("min-price-input");
    const maxInput = document.getElementById("max-price-input");

    if (minInput) {
        if (urlParams.has(minInput.name)) {
            minInput.value = urlParams.get(minInput.name);
        } else {
            minInput.value = DEFAULT_MIN_PRICE;
        }
    }

    if (maxInput && urlParams.has(maxInput.name)) {
        maxInput.value = urlParams.get(maxInput.name);
    }

    // Handle browser back/forward buttons
    window.addEventListener('popstate', function() {
        location.reload();
    });

    // Initial UI update on page load
    updateFilterUI();
});